import { Navbar, Container, Nav, Button } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  FaChartBar,
  FaHistory,
  FaSignOutAlt,
} from "react-icons/fa";

import { signOut } from "firebase/auth";
import { auth } from "./config";

function AdminHeader() {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/admin/login");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Navbar
      bg="white"
      expand="lg"
      className="border-bottom shadow-sm py-3"
    >
      <Container fluid="lg">

        <Navbar.Brand
          as={Link}
          to="/admin/dashboard"
          className="fw-bold"
        >
          Daily Number Admin
        </Navbar.Brand>

        <Navbar.Toggle />

        <Navbar.Collapse>

          <Nav className="ms-auto align-items-lg-center gap-lg-2">

            <Nav.Link
              as={Link}
              to="/admin/dashboard"
              className={
                location.pathname === "/admin/dashboard"
                  ? "fw-bold"
                  : ""
              }
            >
              <FaChartBar className="me-2" />
              Dashboard
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/admin/history"
              className={
                location.pathname === "/admin/history"
                  ? "fw-bold"
                  : ""
              }
            >
              <FaHistory className="me-2" />
              History
            </Nav.Link>

            <Button
              variant="outline-danger"
              size="sm"
              onClick={handleLogout}
            >
              <FaSignOutAlt className="me-2" />
              Logout
            </Button>

          </Nav>

        </Navbar.Collapse>

      </Container>
    </Navbar>
  );
}

export default AdminHeader;